<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Contratos</span>
            <v-spacer></v-spacer>
            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( contratos  , 'contratos')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="getClientes, dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="2">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="fechaini"
                  type="date"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="fechafin"
                  type="date"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="black--text" v-if="getdatosUsuario.admin == 'ADMIN'">
                <div><b>EFECTIVO:</b> {{ formatMoney( totalEfectivo ) }}</div>
                <div><b>TARJETA:</b>  {{ formatMoney( totalTarjeta ) }}</div>
                <div><b>TOTAL FIESTA:</b>    {{ formatMoney( totalFiestaA ) }}</div>
                <div><b>TOTAL MERCANCIA:</b>    {{ formatMoney( totalMercanciaA ) }}</div>
                <div><b>TOTAL GENERAL:</b>    {{ formatMoney( totalGeneral ) }}</div>
                <div><b>ADEUDO FIESTA :</b>    {{ formatMoney( adeudoFiesta ) }}</div>
                <div><b>TOTAL ANTICIPO :</b>    {{ formatMoney( totalAnticipo ) }}</div>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="filterContratos"
                  class="elevation-0"
                  :search="search"
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  :mobile-breakpoint="100"
                  hide-default-footer
                  dense
                >

                  <template v-slot:item.faltante="{ item }">
                    <span color="grey" dark small v-if="getdatosUsuario.admin == 'ADMIN'">
                      {{ formatMoney( item.total - item.anticipo ) }} 
                    </span>
                  </template>

                  <template v-slot:item.anticipo="{ item }">
                    <span color="grey" dark small>
                      {{ formatMoney(item.anticipo ) }} 
                    </span>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn 
                      color="primary" 
                      x-small
                      @click="editItem(item)"
                      class="mr-2"
                    >
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>

                    <v-btn 
                      color="error" 
                      x-small
                      @click="deleteItem(item)"
                      v-if="[94,93].includes( getdatosUsuario.idusuarios )"
                      class="mr-2"
                    >
                      <v-icon small> mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:item.estatus="{ item }">
                    <v-chip color="grey" dark small v-if="!item.estatus">Pendiente</v-chip>
                    <v-chip color="green" dark small v-if="item.estatus">Pagado</v-chip>
                  </template>



                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      small
                    >
                      Actualizar
                    </v-btn>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="800px"
    >
      <v-card>
      	<v-card-title>Datos de la compra</v-card-title>
      	<v-card-text class="black--text">
      		
          <div><b>Cliente</b>        : {{ editedItem.cliente     }} </div>
      		<div><b>Sucursal</b>       : {{ editedItem.sucursal     }} </div>
      		<div><b>Anticipo</b>       :  $ {{ editedItem.anticipo     }}.00 </div>
          <div><b>Costo de la fiesta   </b>  :  $ {{ totalFiesta    }}.00 </div>
          <div><b>Costo de la mercancía</b>  :  $ {{ totalMercancia  }}.00 </div>
      		<div><b>Total</b>          :  $ {{ editedItem.total    }}.00 </div>
      		<div><b>Adeudo</b>         :  $ {{ editedItem.total - editedItem.anticipo }}.00 </div>
          <div><b>Autorizó</b>       :  {{ editedItem.autorizo }} </div>
          <div><b>Fecha</b>          :  {{ editedItem.dia }} </div>
          <div><b>Fecha Texto</b>    :  {{ editedItem.fecha_texto }} </div>
          <div><b>Turno</b>          :  {{ editedItem.turno }} </div>
          <div><b>Tipo pago</b>      :  {{ editedItem.tipo_pago == 1 ? 'EFECTIVO' : 'TARJETA' }} </div>
      		<div><b>Folio ticket</b>   :  {{ editedItem.folio_pago }} </div>

      		<br/>
      		<br/>

      		<label class="black--text text-h6">Platillos seleccionados</label>
      		<v-data-table
            :headers="headersPlatillos"
            :items="editedItem.platillos_detalle"
            class="elevation-0"
            v-if="editedItem.platillos_detalle"
            hide-default-footer
            :items-per-page="editedItem.platillos_detalle.lenght"
          >
          	<template v-slot:item.total="{ item }">
              {{ ( item.cantidad * item.precio ).toFixed( 2 ) }}
            </template>

          </v-data-table>

          <v-divider class="my-4"></v-divider>

          <label class="black--text text-h6">Adicionales seleccionados</label>
      		<v-data-table
            :headers="headersArticulos"
            :items="editedItem.articulos_detalle"
            class="elevation-0"
            v-if="editedItem.articulos_detalle"
            hide-default-footer
            :items-per-page="editedItem.articulos_detalle.lenght"
          >
          	<template v-slot:item.total="{ item }">
              {{ ( item.cantidad * item.precio ).toFixed( 2 ) }}
            </template>

          </v-data-table>

          <v-divider class="my-4"></v-divider>

      		<label class="black--text text-h6">Mercancía seleccionados</label>
      		<v-data-table
            :headers="headersMercancia"
            :items="editedItem.extras_detalle"
            class="elevation-0"
            v-if="editedItem.extras_detalle"
            hide-default-footer
            :items-per-page="editedItem.extras_detalle.lenght"
          >
          	<template v-slot:item.total="{ item }">
              {{ ( item.cantidad * item.precio ).toFixed( 2 ) }}
            </template>

          </v-data-table>

          <v-col cols="12">
            <embed :src="`https://sofsolution.club/contratos/${editedItem.idcontratos}.pdf`" type="application/pdf" width="100%" height="600px"/>
          </v-col>

      	</v-card-text>
      	<v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          	@click="dialogConfirmaEntrega = true"
          	color="primary"
          	dark
          >Confirmar</v-btn>
         </v-card-actions>

         <v-btn
          @click="dialog = false"
          color="primary"
          dark
          absolute
          top
          right
        ><v-icon>mdi-close</v-icon></v-btn>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el contrato?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogConfirmaEntrega" max-width="500px">
      <v-card>
        <v-card-title>
          ¿Estás seguro de confirmar está entrega?
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            @click="dialogConfirmaEntrega = false"
          >Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            @click="saveCompra( )"
          >Sí, confirmo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],
    
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idcontratos:0,
        idproveedores:0,
        articulo:0,
        precio:null,
        fecha_creacion:null,
        deleted:null,
      },

      defaultItem: {
        idcontratos:0,
        idproveedores:0,
        articulo:0,
        precio:null,
        personas:0,
        precio:0,
        fecha_creacion:null,
        deleted:null,
      },

      // Filtros: 
      incio:null,
      fin:null,

      // tabla
      search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      contratos: [],

      headers: [
        { text: 'ID'            , value: 'idcontratos'    },
        { text: 'Cliente'       , value: 'cliente'        },
        { text: 'Vendedor'      , value: 'vendedor'       },
        { text: 'Autorizó'      , value: 'autorizo'       },
        { text: 'Sucursal'      , value: 'sucursal'       },
        { text: 'Fecha'         , value: 'dia'            },
        { text: 'Horario'       , value: 'horario'        },
        { text: 'Turno'         , value: 'turno'          },
        { text: 'Anticipo'      , value: 'anticipo'       },
        { text: 'Faltante'      , value: 'faltante'       },
        { text: 'Estatus'       , value: 'estatus'        },
        { text: 'Alta'          , value: 'fecha_creacion' },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],
      departamentos:[],

      proveedores: [],
      horarios:[],
      clientes:[],
      extras:[],
      articulos:[],
      platillos:[],
      e1: 1,
      clienteManual: false,
      cliente: null,
			email: null,
			telefono: null,
			direccion: null,
			festejado:'',
      dia: null,
      hora:null,
      tematica:null,
      porcumplir:null,

      sucursales:[],

      sucursal: null,

      searchArticulos:'',
      headersArticulos: [
        { text: 'Adicional'     , value: 'adicional'      },
        { text: 'Proveedor'     , value: 'proveedor'      },
        { text: 'Artículo'      , value: 'articulo'       },
        { text: 'Precio'        , value: 'precio'         },
      ],
      articulosSeleccionados: [],

      searchPlatillos:'',
      headersPlatillos: [
        { text: 'Platillo'      , value: 'platillo'       },
        { text: 'horario'       , value: 'horario'        },
        { text: 'Personas'      , value: 'personas'       },
        { text: 'Precio'        , value: 'precio'         },
      ],
      platillosSeleccionados: [],

      searchExtras:'',
      headersExtras: [
        { text: 'Producto'      , value: 'extra'          },
        { text: 'Precio'        , value: 'precio'         },
      ],
      extrasSeleccionados: [],

      anticipo:null,
      tipo_pago:null,

      horario: null,
      headersMercancia: [
        { text: 'Producto'      , value: 'extra'          },
        { text: 'Precio'        , value: 'precio'         },
        { text: 'Cantidad'      , value: 'cantidad'       },
        { text: 'Total'         , value: 'total'          },
      ],

      dialogConfirmaEntrega: false,
      fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      

    }),

    computed: {
      ...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar proveedor' : 'Editar el proveedor'
      },

      total_pago( ){

      	let pagoAdicionales = this.articulosSeleccionados.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);
      	let pagoPlatillos   = this.platillosSeleccionados.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);
      	let pagoExtras      = this.extrasSeleccionados.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);

      	let sumaTotal = pagoAdicionales + pagoPlatillos + pagoExtras

      	return ( sumaTotal )
      },


      faltante( ){

      	return this.total_pago - this.anticipo

      },

      filterHorarios( ){

      	return this.horarios.filter( el => el.idsucursales == this.sucursal )
      },

      filterPlatillos( ){

      	return this.platillos.filter( el => el.idsucursales == this.sucursal && el.idhorarios == this.horario )

      },

      totalFiesta( ){

        if( this.editedItem.articulos_detalle && this.editedItem.platillos_detalle ){
          let pagoAdicionales = this.editedItem.articulos_detalle.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);
          let pagoPlatillos   = this.editedItem.platillos_detalle.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);

          let sumaTotal = pagoAdicionales + pagoPlatillos 

          return ( sumaTotal )

        }

        return 0

      },

      totalMercancia( ){

        if( this.editedItem.extras_detalle ){
          return this.editedItem.extras_detalle.reduce((acc, producto) => acc + parseFloat( producto.precio * producto.cantidad ), 0);

        }else{
          return 0
        }


      },

      filterContratos( ){


        let data = this.contratos

        if( this.fechaini && this.fechafin ){

          data = data.filter( el => el.fecha_creacion.substr( 0,10 ) >= this.fechaini &&  el.fecha_creacion.substr( 0,10 ) <= this.fechafin )

        }

        return data

      },

      totalTarjeta( ){


        let data = this.contratos

        if( this.fechaini && this.fechafin ){

          data = data.filter( el => el.fecha_creacion.substr( 0,10 ) >= this.fechaini &&  el.fecha_creacion.substr( 0,10 ) <= this.fechafin )

        }

        data = data.filter( el => el.tipo_pago == 2 )

        return data.reduce((acc, producto) => acc + parseFloat( producto.anticipo ), 0);

      },

      totalEfectivo( ){


        let data = this.contratos

        if( this.fechaini && this.fechafin ){

          data = data.filter( el => el.fecha_creacion.substr( 0,10 ) >= this.fechaini &&  el.fecha_creacion.substr( 0,10 ) <= this.fechafin )

        }

        data = data.filter( el => el.tipo_pago == 1 )

        return data.reduce((acc, producto) => acc + parseFloat( producto.anticipo ), 0);

      },

      total( ){


        let data = this.contratos

        if( this.fechaini && this.fechafin ){

          data = data.filter( el => el.fecha_creacion.substr( 0,10 ) >= this.fechaini &&  el.fecha_creacion.substr( 0,10 ) <= this.fechafin )

        }

        return data.reduce((acc, producto) => acc + parseFloat( producto.anticipo ), 0);

      },


      totalFiestaA( ){ 

        let sumaTotal = 0

        for( const i in this.filterContratos ){

          const { articulos_detalle, platillos_detalle } = this.filterContratos[i]


          let pagoAdicionales = articulos_detalle.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);
          let pagoPlatillos   = platillos_detalle.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);

          sumaTotal += pagoAdicionales + pagoPlatillos 



        }
        return ( sumaTotal )

      },

      totalMercanciaA( ){ 

        let sumaTotal = 0

        for( const i in this.filterContratos ){

          const { extras_detalle, platillos_detalle } = this.filterContratos[i]


          let pagoAdicionales = extras_detalle.reduce((acc, producto) => acc + parseFloat( producto.precio * producto.cantidad ), 0);

          sumaTotal += pagoAdicionales  



        }
        return ( sumaTotal )

      },

      totalGeneral( ){ 

        let sumaTotal = 0

        for( const i in this.filterContratos ){

          const { articulos_detalle, platillos_detalle, extras_detalle } = this.filterContratos[i]


          let pagoAdicionales = articulos_detalle.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);
          let pagoPlatillos   = platillos_detalle.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);
          let extras = extras_detalle.reduce((acc, producto) => acc + parseFloat( producto.precio * producto.cantidad ), 0);

          sumaTotal += pagoAdicionales + pagoPlatillos + extras



        }
        return ( sumaTotal )

      },

      adeudoFiesta( ){ 

        let anticipo = this.filterContratos.reduce((acc, producto) => acc + parseFloat( producto.anticipo ), 0);


        return this.totalGeneral - anticipo

      },

      totalAnticipo( ){ 

        let anticipo = this.filterContratos.reduce((acc, producto) => acc + parseFloat( producto.anticipo ), 0);


        return anticipo

      },

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
    },

    methods: {
      initialize () {
        this.cargar = true
        this.contratos = []
        return this.$http.get('contratos.list').then(response=>{
          this.contratos = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.contratos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.contratos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('contratos.update.eliminar/' + this.editedItem.idcontratos, this.editedItem).then(response=>{
          this.cargar = true
          this.closeDelete()
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      addContrato( ){

      	const payload = {

      		cliente   : this.cliente,
      		articulos : this.articulosSeleccionados,
      		platillos : this.platillosSeleccionados,
      		extras    : this.extrasSeleccionados,
      		festejado : this.festejado,
					dia       : this.dia,
					hora      : this.horario,
					tematica  : this.tematica,
					porcumplir: this.porcumplir,
					anticipo  : this.anticipo,
					tipo_pago : this.tipo_pago,
					idusuarios: this.getdatosUsuario.idusuarios,
					sucursal  : this.sucursal,
					total     : this.total_pago
      	}

      	return this.$http.post('contratos.add', payload ).then(response=>{
      		this.cliente = null
					this.articulosSeleccionados = []
					this.platillosSeleccionados = []
					this.extrasSeleccionados = []
					this.festejado = null
					this.dia = null
					this.hora = null
					this.tematica = null
					this.porcumplir = null
					this.anticipo = null
					this.tipo_pago = null
					this.e1 = 1
					this.close( )

      		this.validarSuccess('Datos grabados correctamente')
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if(this.editedItem.proveedor == ''){
          this.validarErrorDirecto('Favor de llenar todos los campos')
        }
        this.cargar = true

        if (this.editedIndex > -1) {
          // Lo mandapos por el EP
          this.$http.put('contratos.update/' + this.editedItem.idarticulos, this.editedItem).then(response=>{
            this.close()
            this.validarSuccess( response.body.message )
            this.initialize()
          }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {
          // Lo mandapos por el EP
          this.$http.post('contratos.add', this.editedItem).then(response=>{
            this.close()
            this.initialize()
            this.cargar = false
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }
      },

      saveCompra( ){
        this.cargar = true


        const payload = {

          idcontratos  : this.editedItem.idcontratos,
          idautorizo          : this.getdatosUsuario.idusuarios,
          data: this.editedItem

        }

        // Lo mandapos por el EP
        this.$http.post('contratos.update', payload).then(response=>{
          this.dialogConfirmaEntrega = false
          this.validarSuccess('Datos actualizados correctamente')
          this.close( )
          this.initialize( )
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      formatMoney(value) {
        // Formateamos el número como moneda en dólares (USD)
        return value.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
      },

    },
  }
</script>


